export const IbcoEvents = {
  GetTransactions: 'Ibco.GetTransactions',
  TransactionsReturned: 'Ibco.TransactionsReturned',
  GetStartPrice: 'Ibco.GetStartPrice',
  StartPriceReturned: 'Ibco.StartPriceReturned',
  BuyArmor: 'Ibco.BuyArmor',
  BuyArmorCompleted: 'Ibco.BuyArmorCompleted',
  GetMinimalProvideAmount: 'Ibco.GetMinimalProvideAmount',
  MinimalProvideAmountReturned: 'Ibco.MinimalProvideAmountReturned',
  GetTotalDistributed: 'Ibco.GetTotalDistributed',
  TotalDistributedReturned: 'Ibco.TotalDistributedReturned',
  GetTotalProvided: 'Ibco.GetTotalProvided',
  TotalProvidedReturned: 'Ibco.TotalProvidedReturned',
  GetUserProvided: 'Ibco.GetUserProvided',
  UserProvidedReturned: 'Ibco.UserProvidedReturned',
}
